function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M260,65.25c-.05-12.82-6.61-20-19.35-21C208.84,41.75,180.51,30,155,11.56,143.15,3,133.42,3,121.48,11.61,96,29.91,67.69,42,35.89,44.35c-14.66,1.1-20.58,9.94-20.5,23.77.2,34.36.72,57.12-.16,79.48-1.38,35.07,12.83,63.43,37.26,87.3,21.66,21.16,47.35,36,75.54,46.72,4.7,1.78,9.24,3.27,14.7,2.05,67.54-15.08,116.28-74.81,117.2-144,.1-7.33,0-14.66,0-22C260,100.2,260,82.72,260,65.25ZM137,254.42v-105H50.58s-5.08,0-5.08-13.55V81.89s0-7.06,3.39-7.06c0,0,71.15-13.55,88.1-37.27V149.38H238.63S225.08,237.47,137,254.42Z"
});

var SvgSecurity = function SvgSecurity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 276 287",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecurity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/security.a00e118e.svg";
export { ForwardRef as ReactComponent };